import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styled from '@mui/material/styles/styled';
import { HeartIcon } from '../../../../assets/images/activityIcons';
import BoxData from '../../../../components/boxData';
import ProgressBar from '../../../../components/charts/progressBar';
import { CHALLENGE_HEARTBEAT_MAX } from '../../../../constants';

// Styled components
const PaperCard = styled(Box)(({ theme, background }) => ({
    borderRadius: '20px',
    padding: '20px',
    boxShadow: theme.palette.shadows?.custom?.card || '0px 2px 8px rgba(0, 0, 0, 0.1)',
    border: 'none',
    position: 'relative',
    background: background || theme.palette.figma.block,
}));

const HeartRateDataCard = ({
    physicalRecord = {},
    sx = {},
    onClick = () => { },
    background = null
}) => {
    const theme = useTheme();

    const defaultHeartRate = {
        rangeStart: 40,
        rangeEnd: CHALLENGE_HEARTBEAT_MAX,
    };

    return (
        <PaperCard sx={sx} background={background} onClick={onClick}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                {/* Main Content */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                        }}
                    >
                        <HeartIcon size={30} />
                        <Typography
                            sx={{
                                textAlign: 'center',
                                fontSize: '30px',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                lineHeight: 'normal',
                                letterSpacing: '-0.9px',
                            }}
                        >
                            {physicalRecord?.curHeartRate || 0}
                        </Typography>
                        <Typography
                            sx={{
                                color: theme.palette.figma.white[60],
                                textAlign: 'center',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                lineHeight: 'normal',
                                letterSpacing: '-0.42px',
                            }}
                        >
                            bpm
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '150px',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        <BoxData
                            data={
                                (physicalRecord?.minHeartRate || 0) +
                                '-' +
                                (physicalRecord?.maxHeartRate || 0)
                            }
                        />
                        <ProgressBar
                            current={physicalRecord?.curHeartRate || 0}
                            rangeStart={physicalRecord?.rangeStart || defaultHeartRate.rangeStart}
                            rangeEnd={physicalRecord?.rangeEnd || defaultHeartRate.rangeEnd}
                            start={physicalRecord?.minHeartRate || 0}
                            end={physicalRecord?.maxHeartRate || 0}
                            height="10px"
                            showCurrentIndicator={false}
                            showProgress={true}
                            progressColor="#FF00D0"
                            sx={{ alignSelf: 'stretch' }}
                        />
                    </Box>
                </Box>
            </Box>
        </PaperCard>
    );
};

export default HeartRateDataCard;
